import {Component, OnInit, OnDestroy,ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {Formatters} from 'angular-slickgrid';
import {NgbModal ,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {CustomInputEditor} from '../custom-inputEditor';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-followup',
    templateUrl: './followup.component.html',
    styleUrls: ['./followup.component.css']
})
export class FollowupComponent implements OnInit, OnDestroy {

    displayed = true;
    subject: string;
    totalData = 0;
    show: boolean;
    selected: number;
    respObject: any;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;
    displayData: any;
    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    offset: number;
    // =============================
    psno: string;
    username: string;
    phoneno: string;
    email: string;
    categories = [];
    tickets = [];
    ticketSelected: number;
    categorySelected: string;
    categoryName: string;
    ticket_type: string;
    priorities = [];
    prioritySelected: number;
    priority_name: string;
    categoryArr = [];
    dataLoaded: boolean;
    isShow = false;

    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    categrySelected: any;
    cats: any;
    userName: string;
    showExportBtn = true;
    isExportDisable = false;
    dataExcel = [];
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;


    constructor(private _rest: RestApiService, private messageService: MessageService,
                private route: Router, private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    // console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            item.user_id = this.messageService.getUserId();
                            this._rest.updateFollowupLt(item).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.notifier.notify('success', 'Edit Successful');
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteFollowUpLt({user_id: this.messageService.getUserId(), id: item.id}).subscribe((res) => {
                                this.respObject = res;
                                // console.log(JSON.stringify(this.respObject));
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                    this.notifier.notify('success', 'Followup user Deleted successfully');
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            // console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
    }

    ngOnInit() {
        this.isShow = false;
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Followup',
            openModalButton: 'Add Followup',
            searchModalButton: 'Search',
            breadcrumb: 'Followup',
            folderName: 'All Followup',
            tabName: 'Followup',
            exportBtn: 'Export to excel',
            
        };
        this.psno = '';
        this.username = '';
        this.phoneno = '';
        this.email = '';
        let columnDefinitions = [];
        columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {id: 'type', name: 'Ticket Type', field: 'ticketType', sortable: true, filterable: true},
            {id: 'categoryName', name: 'Category Name', field: 'categoryName', sortable: true, filterable: true},
            {id: 'priority', name: 'Priority', field: 'priority', sortable: true, filterable: true},
            {
                id: 'userName', name: 'User Name', field: 'userName', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            }
        ];

        if (this.clientId === 2) {
            columnDefinitions.push({
                id: 'psNo', name: 'Ps No', field: 'psNo', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            },);
        }
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }

        // this.searchData.valueChanges.subscribe(
        //   name => {
        //       this.isLoading = true;
        //
        //
        //       this._rest.searchAllFollowUp( name, this.clientId).subscribe((res1) => {
        //           this.respObject = res1;
        //           this.isLoading = false;
        //           if (this.respObject.success) {
        //               this.cats = this.respObject.details;
        //               //console.log("true"+ JSON.stringify(this.cats));
        //           } else {
        //               this.notifier.notify('error', this.respObject.errorMessage);
        //           }
        //       }, (err) => {
        //           this.isLoading = false;
        //           this.notifier.notify('error', this.messageService.SERVER_ERROR);
        //       });
        //   });
    }

    onPageLoad() {
        if (this.clientId === 2) {
            this.isShow = true;
        }
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.tickets = this.respObject.details;
                this.ticketSelected = 0;
                this.getPriority();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();
    }

    getPriority() {
        this._rest.getBusinessPriorityTicketTypeWise(this.clientId, this.ticketSelected).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Priorities'});
                this.priorities = this.respObject.details;
                this.prioritySelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    exportToExcel() {
        this.isExportDisable = true;

        // console.log("okkk" +this.clientId);
        this._rest.getAllFollowUp(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.dataExcel = this.respObject.details;
                this.isExportDisable = false;
                // console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.psno = '';
            this.username = '';
            this.phoneno = '';
            this.email = '';
            this.modalService.open(content).result.then((result) => {
            }, (reason) => {

            });
        }

    }

    searchModal() {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.psno = '';
            this.username = '';
            this.phoneno = '';
            this.email = '';
            // this.modalService.open(scarch_content).result.then((result) => {
            // }, (reason) => {

            // });
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });

        }

    }

    search() {
        this._rest.searchAllFollowUp(this.categrySelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.cats = this.respObject.details;
                this.messageService.setGridData(this.cats);
                this.messageService.setTotalData(this.cats.length);
                this.searchModalReference.close();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    save() {
        const data = {
            clientId: this.clientId, ticket_type_id: this.ticketSelected, username: this.username,
            psno: this.psno, phno: this.phoneno, email: this.email, createdBy: this.messageService.getUserId(),
            priority_id: this.prioritySelected
        };
        if (this.categorySelected === '-1') {
            data['category_id'] = this.categoryArr;
        } else {
            this.categoryArr = [];
            this.categoryArr.push(this.categorySelected);
            data['category_id'] = this.categoryArr;
        }
        // console.log('insert data==========', this.selectedSupportGroupName.join(', '));
        if (!this.messageService.isBlankField({
            ticket_type_id: this.ticketSelected,
            category_id: this.categorySelected,
            username: this.username
        })) {
            this._rest.addFollowup(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.categoryArr = [];
                    this.ticketSelected = 0;
                    this.categorySelected = '0';
                    this.psno = '';
                    this.username = '';
                    this.phoneno = '';
                    this.email = '';
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }

    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getFollowupLt(offset, this.pageSize, paginationType, this.clientId).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    onTicketChange(selectedIndex: any) {
        this.ticket_type = this.tickets[selectedIndex].name;
        this.getCategory();
        this.getPriority();
    }

    onPriorityChange(selectedIndex: any) {
        this.priority_name = this.priorities[selectedIndex].name;
    }

    onCategoryChange(selectedIndex: any) {
        this.categoryName = this.categories[selectedIndex].name;
    }

    getCategory() {
        this._rest.getCategoryByTicketTypeNDynamicLevel(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                // console.log(this.respObject);
                this.respObject.details.unshift({id: 0, name: 'Select Category'}, {id: -1, name: 'Select All'});
                this.categories = this.respObject.details;
                for (let i = 2; i < this.categories.length; i++) {
                    this.categoryArr.push(this.categories[i].id);
                }
                this.categorySelected = '0';
            } else {
                this.categories = [];
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

}
